// extracted by mini-css-extract-plugin
export var carrierIcon = "_xt-0";
export var carrierLogo = "_xt-1";
export var detailsSection = "_xt-2";